module.exports = __webpack_public_path__ + "img/coupon_tutorial_ROMAPI03.7dc65d85.jpg";